<div class="container-fluid container" aria-labelledby="personal-info-title">
  <div class="row fun__main">
    <div class="fun__user-info">
      <div class="fun__mfa">
        <h1 id="personal-info-title" class="fun__mfa__title" tabindex="0">Personal information</h1>
        <p class="fun__form__input-label fun__form__item" id="personal-info-description" tabindex="0">
          We need a bit more information to make sure it’s really you. All fields are required unless otherwise marked.
        </p>

        <form
          [formGroup]="personalInfoForm"
          class="fun__form fun__form--inverse js-form"
          action=""
          autocomplete="off"
          aria-describedby="personal-info-description"
        >
          <!-- Address Section -->
          <div class="fun__form__row">
            <label class="fun__form__input-label" for="addressLine1">
              <span class="fun__form__label-text">Address Line:*</span>
              <input
                id="addressLine1"
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="addressLine1"
                aria-required="true"
                aria-describedby="addressLine1-error"
                autocomplete="address-line1"
              />
              <div
                id="addressLine1-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['addressLine1'].errors?.['required']"
                role="alert"
              >
                Please enter your Address Line
              </div>
            </label>

            <label class="fun__form__input-label" for="addressLine2">
              <span class="fun__form__label-text">Address Line 2:</span>
              <input
                id="addressLine2"
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="addressLine2"
                aria-required="true"
                aria-describedby="addressLine2-error"
                autocomplete="address-line2"
              />
              <div
                id="addressLine2-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['addressLine2'].errors?.['required']"
                role="alert"
              >
                Please enter your Address Line 2
              </div>
            </label>
          </div>

          <!-- City and State Section -->
          <div class="fun__form__row">
            <label class="fun__form__input-label" for="city">
              <span class="fun__form__label-text">City:*</span>
              <input
                id="city"
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="city"
                aria-required="true"
                aria-describedby="city-error"
                autocomplete="address-level2"
              />
              <div
                id="city-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['city'].errors?.['required']"
                role="alert"
              >
                Please enter your City
              </div>
            </label>

            <label class="fun__form__input-label" for="state">
              <span class="fun__form__label-text">State:*</span>
              <input
                id="state"
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="state"
                aria-required="true"
                aria-describedby="state-error"
                autocomplete="address-level1"
              />
              <div
                id="state-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['state'].errors?.['required']"
                role="alert"
              >
                Please enter your State
              </div>
            </label>
          </div>

          <!-- Zip Code and Email Section -->
          <div class="fun__form__row">
            <label class="fun__form__input-label" for="zipCode">
              <span class="fun__form__label-text">Zip Code:*</span>
              <input
                id="zipCode"
                type="text"
                class="fun__form__input js-form-input is-required"
                formControlName="zipCode"
                aria-required="true"
                aria-describedby="zipCode-error"
                autocomplete="postal-code"
              />
              <div
                id="zipCode-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['zipCode'].errors?.['required']"
                role="alert"
              >
                Please enter your Zip Code
              </div>
            </label>

            <label class="fun__form__input-label" for="emailAddress">
              <span class="fun__form__label-text">Email:*</span>
              <input
                id="emailAddress"
                type="email"
                class="fun__form__input js-form-input is-required"
                formControlName="emailAddress"
                aria-required="true"
                aria-describedby="emailAddress-error"
                autocomplete="email"
              />
              <div
                id="emailAddress-error"
                class="fun__form__error-message"
                *ngIf="
                  isSubmitted && (form['emailAddress'].errors?.['required'] || form['emailAddress'].errors?.['email'])
                "
                role="alert"
              >
                Please enter your Email Address
              </div>
            </label>
          </div>

          <!-- Phone Section -->
          <div class="fun__form__row">
            <label class="fun__form__input-label phone-section" for="phone">
              <span class="fun__form__label-text">Phone:*</span>
              <input
                id="phone"
                type="tel"
                class="fun__form__input js-form-input is-required"
                formControlName="phone"
                aria-required="true"
                aria-describedby="phone-error"
                autocomplete="tel"
              />
              <div
                id="phone-error"
                class="fun__form__error-message"
                *ngIf="
                  isSubmitted &&
                  (form['phone'].errors?.['required'] ||
                    form['phone'].errors?.['minlength'] ||
                    form['phone'].errors?.['maxlength'])
                "
                role="alert"
              >
                Please enter your Phone number of 10 digit.
              </div>
            </label>
          </div>

          <!-- Communication Type Section -->
          <div class="fun__form__row" role="radiogroup" aria-labelledby="communication-type-label">
            <div class="fun__form__input-label_radio">
              <label>
                <input
                  type="radio"
                  class="radio js-form-input is-required"
                  name="communicationType"
                  value="Sms"
                  formControlName="communicationType"
                  aria-describedby="communicationType-error"
                />
                Text
              </label>
              <label>
                <input
                  type="radio"
                  class="radio js-form-input is-required"
                  name="communicationType"
                  value="Voice"
                  formControlName="communicationType"
                  aria-describedby="communicationType-error"
                />
                Audio
              </label>
              <div
                id="communicationType-error"
                class="fun__form__error-message"
                *ngIf="isSubmitted && form['communicationType'].errors?.['required']"
                role="alert"
              >
                Please select a Communication Type
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="fun__form__row">
            <button
              type="button"
              id="submitBtn"
              (click)="onSubmit()"
              class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
              aria-label="Submit"
            >
              <span>Submit</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
